import { getTranslate } from 'react-localize-redux/lib/index';
import { connect } from 'react-redux';
import { AuthActions } from '../../../../redux/auth';
import { Menu } from './Menu';

const mapStateToProps = state => ({
  strings: getTranslate(state.locale),
});

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(AuthActions.logoutRequested()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
